import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { useEffect, useMemo, useState } from 'react'
import { flatten } from '@/lib/utils.ts'
import { selectAllProperty } from '@/routes/root/lib/staticProperties.tsx'
import { getPureProperties } from '@/components/common/propertyPopoverOverlay/helpers.ts'

export function useHandleProperties(
  properties: PopoverProperty[],
  onSelectParent: ((val: string) => void) | undefined,
  open: boolean,
  selectAll?: () => void,
  showAllSearchResults?: boolean,
  debug?: boolean,
  removeSelectedParent?: () => void,
) {
  const combinedProps: PopoverProperty[] = useMemo(() => {
    if (selectAll) return [selectAllProperty, ...properties]
    return properties
  }, [properties, selectAll])
  const [currentProperties, setCurrentProperties] = useState<PopoverProperty[]>(combinedProps)

  const propertiesFlat = useMemo(
    () => combinedProps.flatMap(property => flatten(property)),
    [combinedProps],
  )
  const [selectedNestedProperties, setSelectedNestedProperties] = useState<
    PopoverProperty[][] | []
  >([])

  if (debug) {
    // console.log(currentProperties, `curr`)
    // console.log(combinedProps, `combined`)
  }

  function handleSelectParent(property: PopoverProperty) {
    if (!property.children) return

    setCurrentProperties(property.children)

    onSelectParent && onSelectParent(property.value)

    if (Array.isArray(property.children)) {
      setSelectedNestedProperties(curr => [...curr, property.children as PopoverProperty[]])
    }
  }

  function handleGoBack() {
    setSelectedNestedProperties(curr => {
      const updated = [...curr]
      updated.pop()

      if (updated.length === 0) {
        // back to default
        setCurrentProperties(combinedProps)
        removeSelectedParent?.()
        return updated
      }

      const currentlyOpened = updated[updated.length - 1]
      if (!currentlyOpened) return updated
      setCurrentProperties(currentlyOpened)

      return updated
    })
  }

  const handleValueChange = (value: string) => {
    if (value === '') {
      setCurrentProperties(combinedProps)
    }
  }

  // useEffect(() => {
  //   if (open) {
  //     setCurrentProperties(combinedProps)
  //     setSelectedNestedProperties([])
  //   }
  // }, [open, combinedProps])

  useEffect(() => {
    if (open && showAllSearchResults) {
      setCurrentProperties(combinedProps)
    }
  }, [open, combinedProps, showAllSearchResults])

  useEffect(() => {
    if (open) {
      // setCurrentProperties(combinedProps)
      // setSelectedNestedProperties([])
    }
  }, [open])

  const pureProps = getPureProperties(combinedProps)

  return {
    setCurrentProperties,
    currentProperties,
    selectedNestedProperties,
    handleSelectParent,
    handleGoBack,
    propertiesFlat,
    handleValueChange,
    pureProps,
  }
}
